module.exports = __webpack_public_path__ + "static/media/put_card_on_table.6ccf6da5.mp3";